import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Station from './station';
import StationDetail from './station-detail';
import StationUpdate from './station-update';
import StationDeleteDialog from './station-delete-dialog';

const StationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Station />} />
    <Route path="new" element={<StationUpdate />} />
    <Route path=":id">
      <Route index element={<StationDetail />} />
      <Route path="edit" element={<StationUpdate />} />
      <Route path="delete" element={<StationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default StationRoutes;
